import axios from 'axios'
import { MessageBox } from 'element-ui'
import store from '@/store/index'
import config from '@/config/app.config'
import router from '@/router'

const getErrorMessage = (status) => {
  switch (status) {
    case 400: return '请求错误'
    case 401: return '未授权，请重新登录'
    case 403: return '拒绝访问'
    case 404: return '请求出错'
    case 408: return '请求超时'
    case 500: return '服务器错误'
    case 501: return '功能正在路上'
    case 502: return '网络错误'
    case 503: return '服务不可用'
    case 504: return '网络超时'
    case 505: return 'HTTP版本不受支持'
    default: return `连接出错(${status})!`
  }
}

const request = (method, url, server, params, needToken = true, header = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: needToken ? `Bearer ${store.state.token}` : '',
    ...header
  }
  return new Promise((resolve, reject) => {
    axios({
      method,
      headers,
      baseURL: config[server],
      url,
      timeout: 15000,
      params: method === 'GET' ? params : null, // 是即将与请求一起发送的 URL 参数
      data: method === 'POST' || method === 'PUT' ? params : null // 是作为请求主体被发送的数据
    }).then(res => {
      resolve(res.data)
    }).catch(error => {
      let message = ''
      // 网络断开时的提示
      if (!error.response) {
        MessageBox({
          title: '系统提示',
          message: '网络连接错误'
        })
        reject(error)
        return
      }
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else {
        message = getErrorMessage(error.response.status)
      }
      MessageBox({
        title: '系统提示',
        message,
        callback () {
          if (error.response.status === 401 && needToken) {
            sessionStorage.clear()
            const url = window.location.href
            router.push({
              path: '/login',
              query: {
                redirect: url.slice(url.indexOf('#') + 1)
              }
            })
          }
        }
      })
      reject(error)
    })
  })
}

export default request
